import React from 'react';

import {QuoteImage} from 'src/components/editorial/QuoteImage';

import {SanityFloatedImage} from 'types/generated';

export const FloatedImage: React.FC<SanityFloatedImage> = props => {
  return (
    <section
      className="w-full md:w-1/2 md:mr-8 md:float-left pb-8 py-8 md:py-0 relative mb-4"
      data-module="image-w-quote"
    >
      <div className="w-full relative z-20">
        <QuoteImage {...props.image} />
        <div className="type-xs-p mt-2">{props.image?.caption}</div>
      </div>
    </section>
  );
};
